<div class="wrapper" *ngIf="displayPage">
    <div class="sidebar" data-color="azure" data-image="">
        <app-sidebar></app-sidebar>
        <div class="sidebar-background" style="background-image: url(/assets/img/sidebar-0.jpg)"></div>
    </div>

    <div class="main-panel">
        
        <nav class="navbar navbar-default" (click)="sidebarToggle()">
            <div class="container-fluid">
            </div>
        </nav>

        <div class="main-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card shadow">
                            <div class="container-fluid">
                                <p>Your assessment period has ended. If you have any feedback you wish to provide, please contact the coach that assigned this assessment to you.</p>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> 